module.exports = __webpack_public_path__ + "static/img/wjx.b4ef983.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wjx.jpg
// module id = uk1E
// module chunks = 1